import script from "./Payables.vue?vue&type=script&setup=true&lang=js"
export * from "./Payables.vue?vue&type=script&setup=true&lang=js"

import "./Payables.vue?vue&type=style&index=0&id=1da87c8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da87c8a"]])

export default __exports__